import { getDefaultClient } from '@dynamic-labs-sdk/client/core';

import { addWaasSolanaExtension } from '../waas/addWaasSolanaExtension';
import { addSolanaWalletStandardExtension } from '../walletStandard/addSolanaWalletStandardExtension';

/**
 * Adds the Solana extension to the Dynamic client.
 *
 * This is a convenience function that adds both the Solana Wallet Standard extension
 * and the Dynamic WaaS Solana extension, enabling support for all Solana wallet types
 * including standard wallets and embedded wallets managed by Dynamic's infrastructure.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addSolanaExtension = (client = getDefaultClient()): void => {
  addSolanaWalletStandardExtension(client);
  addWaasSolanaExtension(client);
};
